import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '15.7 13.87'
  const rightPupilTransformOrigin = '43.7 13.87'
  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path
              className="cls-2"
              d="M23.68,20.01s.78-13.15-8.49-13.15c-4.14,0-7.5,3.36-7.5,7.5s3.35,7.5,7.5,7.5c5.39-.01,8.49-1.85,8.49-1.85Z"
              fill={COLORS.WHITE}
            />
            <path
              className="cls-3"
              d="M15.2,22.35c-4.41,0-8-3.59-8-8s3.59-8,8-8c2.33,0,4.26,.79,5.74,2.36,3.64,3.86,3.26,11.02,3.24,11.32l-.02,.26-.23,.14c-.13,.08-3.27,1.91-8.74,1.92Zm0-15c-3.86,0-7,3.14-7,7s3.14,7,7,7c4.35,0,7.19-1.25,8-1.65,.03-1.33-.02-7.16-2.98-10.3-1.28-1.36-2.97-2.05-5.01-2.05Z"
              fill={outline}
            />
          </g>
          <path
            className="cls-1"
            d="M15.7,19.85c3.31,0,6-2.69,6-6s-2.69-6-6-6-6,2.69-6,6,2.69,6,6,6Z"
            fill={`url(#${randomGradientId1})`}
          />
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path className="cls-4" d="M15.7,16.87c1.66,0,3-1.34,3-3s-1.34-3-3-3-3,1.34-3,3,1.34,3,3,3Z" fill={pupil} />
            {showEyeLiner && (
              <path d="M24.17,20.3c-.8-5.44-3.03-13.11-9.73-12.54-3.54,.26-6.72,3.04-7.24,6.64-.58-4.11,3.09-7.83,7.07-8.29,7.8-.96,10.88,7.84,9.89,14.19h0Z" />
            )}
          </g>
          <path className="cls-2" d="M17.7,12.85c.55,0,1-.45,1-1s-.45-1-1-1-1,.45-1,1,.45,1,1,1Z" fill={COLORS.WHITE} />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path
              className="cls-2"
              d="M35.72,20.01s-.78-13.15,8.49-13.15c4.14,0,7.5,3.36,7.5,7.5s-3.35,7.5-7.5,7.5c-5.39-.01-8.49-1.85-8.49-1.85Z"
              fill={COLORS.WHITE}
            />
            <path
              className="cls-3"
              d="M44.2,22.35c-5.47,0-8.61-1.84-8.74-1.92l-.23-.14-.02-.26c-.02-.3-.4-7.46,3.24-11.32,1.48-1.57,3.41-2.36,5.74-2.36,4.41,0,8,3.59,8,8s-3.59,8-8,8Zm-8-2.65c.81,.4,3.64,1.64,8,1.65,3.86,0,7-3.14,7-7s-3.14-7-7-7c-2.04,0-3.73,.69-5.01,2.05-2.96,3.14-3.01,8.97-2.98,10.3Z"
              fill={outline}
            />
          </g>
          <path
            className="cls-5"
            d="M43.7,19.85c3.31,0,6-2.69,6-6s-2.69-6-6-6-6,2.69-6,6,2.69,6,6,6Z"
            fill={`url(#${randomGradientId2})`}
          />
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path className="cls-4" d="M43.7,16.87c1.66,0,3-1.34,3-3s-1.34-3-3-3-3,1.34-3,3,1.34,3,3,3Z" fill={pupil} />
            {showEyeLiner && (
              <path d="M52.2,14.4c-.93-4.64-6.08-7.84-10.56-6.23-4.63,1.92-5.79,7.59-6.4,12.13-.37-4.93,.73-11.38,5.82-13.6,5.06-2.36,12.23,1.86,11.14,7.7h0Z" />
            )}
          </g>
          <path className="cls-2" d="M45.7,12.85c.55,0,1-.45,1-1s-.45-1-1-1-1,.45-1,1,.45,1,1,1Z" fill={COLORS.WHITE} />
        </g>
      </g>

      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="15.7"
          y1="177.89"
          x2="15.7"
          y2="190.26"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="43.7"
          x2="43.7"
          y1="177.89"
          y2="190.26"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
